export default __webpack_public_path__ + "static/media/london_flag.621777c9.png";